var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "AnnouncementDetails" },
      [
        _c(
          "el-form",
          {
            ref: "mainform",
            attrs: {
              model: _vm.mainform,
              "label-width": "150px",
              rules: _vm.rules
            }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "单据编号：" } },
              [
                _c("el-input", {
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.mainform.ID,
                    callback: function($$v) {
                      _vm.$set(_vm.mainform, "ID", $$v)
                    },
                    expression: "mainform.ID"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "发布方式：" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.mainform.TYPE_ID,
                      callback: function($$v) {
                        _vm.$set(_vm.mainform, "TYPE_ID", $$v)
                      },
                      expression: "mainform.TYPE_ID"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [
                      _vm._v("公司公告")
                    ]),
                    _c("el-radio", { attrs: { label: 2 } }, [
                      _vm._v("供应商须知")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "日期：", prop: "ISSUE_DATE" } },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    type: "date",
                    placeholder: "选择日期",
                    format: "yyyy-MM-dd",
                    "value-format": "yyyy-MM-dd"
                  },
                  model: {
                    value: _vm.mainform.ISSUE_DATE,
                    callback: function($$v) {
                      _vm.$set(_vm.mainform, "ISSUE_DATE", $$v)
                    },
                    expression: "mainform.ISSUE_DATE"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "公告主题：", prop: "THEME" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.mainform.THEME,
                    callback: function($$v) {
                      _vm.$set(_vm.mainform, "THEME", $$v)
                    },
                    expression: "mainform.THEME"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "公告内容：", prop: "CONTENT" } },
              [_c("WEditor", { ref: "textarea" })],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "附件：" } },
              [
                _c("el-input", {
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.mainform.ATTACHMENT_NAME,
                    callback: function($$v) {
                      _vm.$set(_vm.mainform, "ATTACHMENT_NAME", $$v)
                    },
                    expression: "mainform.ATTACHMENT_NAME"
                  }
                }),
                _c(
                  "el-upload",
                  {
                    ref: "upload",
                    staticClass: "upload-demo",
                    attrs: {
                      headers: _vm.handleUploadHeader(),
                      data: _vm.UploadParamVal,
                      action: _vm.uploadUrl,
                      "on-preview": _vm.handlePreview,
                      "on-remove": _vm.handleRemove,
                      "on-change": _vm.handleUpload,
                      "on-exceed": _vm.handleExceed,
                      "on-success": _vm.handleAvatarSuccess,
                      "file-list": _vm.fileList,
                      "auto-upload": true,
                      limit: 1
                    }
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", type: "primary" } },
                      [_vm._v("点击上传")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "文档编号：" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.mainform.FILE_CODE,
                    callback: function($$v) {
                      _vm.$set(_vm.mainform, "FILE_CODE", $$v)
                    },
                    expression: "mainform.FILE_CODE"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: " 是否在首页显示：" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.mainform.IS_SHOW_INDEX,
                      callback: function($$v) {
                        _vm.$set(_vm.mainform, "IS_SHOW_INDEX", $$v)
                      },
                      expression: "mainform.IS_SHOW_INDEX"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }